import React from "react";

import './Footer.css';
import { useLocation } from "react-router-dom";
import { MailForm } from "../mail-form/MailForm";
import { OpeningHoursContent } from "../opening-hours/OpeningHoursContent";

export const Footer = (): JSX.Element => {

    const location: string = useLocation().pathname;
    
    return (
        <footer className="beige-bg">
            <div className="container">
                { (location === '/' || location === '/menu') &&
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-5 offset-lg-1 col-xl-4 offset-xl-2 text-center fly-left">
                        <img src="/img/contact.webp" 
                             alt="Mouth with a speaking bubble"
                             height="100"/>
                        <h5 className="champ-title">Contact</h5>
                        <p className="">
                            Hamngatan 4<br />
                            111 47 Stockholm<br />
                            <a href="mailto:reservations@hallwylska.com">
                                reservations@hallwylska.com
                            </a><br />
                            {/* <a href="tel:+46855807504">
                                +46 8 558 075 04
                            </a> */}
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-5 col-xl-4 text-center fly-right mt-5 mt-md-0">
                        <img src="/img/hours.webp"
                             alt="Two hands with watches"
                             height="100"/>
                        <h5 className="champ-title">Opening Hours</h5>
                        <div className="">
                            <OpeningHoursContent />
                        </div>
                        {/* <p className="">
                        Friday & Saturday: 20:00 – 02:00
                        <br />
                        (Kitchen closes at 01:00)
                        </p>
                        <p className="">
                            <strong>We are open for Lunch Saturday (21/9) 11.30-15.00</strong><br />
                        </p>
                        <p className="">
                            Wednesday - Saturday 17:00 - Late <br />
                        </p>
                        <p className="">
                            Season ends w39 (or w40 if weather permits!)<br />
                        </p> */}
                    </div>
                </div>}
                <MailForm />
                <div className="row pt-5 pb-4">
                    <div className="footer-social text-center mb-3">
                        <a
                            href="https://www.instagram.com/hallwylskarestaurang/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            className="footer-instagram-link"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                            >
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                            </svg>
                        </a>
                    </div>
                    <p className="text-center mb-1">
                        <strong>
                            Hallwylska Restaurang | Hamngatan 4 | Stockholm
                        </strong>
                    </p>
                    <p className="text-center copy">
                        Copyright &copy; 2023-2026 Hallwylska Restaurang
                    </p>
                </div>
            </div>      
        </footer>
    )
}